// extracted by mini-css-extract-plugin
module.exports = {"titleInputContainer":"TitleSection_titleInputContainer__1PdN7","error":"TitleSection_error__3jppC"};